import React from 'react';
import { PopOut } from '@econsult/econsult-ui/dist/components/PopOut';
import Button from 'components/Button';
import _capitalize from 'lodash/capitalize';
import { Template } from 'store/reducer/templates';
import {
  InnerWrapper,
  PopOutScrollView,
  StyledArrowDown,
  StyledPopOutBody,
  FooterManageButtonContainer,
  ListItemContainer,
  TemplateNameText,
  TemplateTypeText,
} from './styles';

interface TemplateManagerProps {
  isOpen: boolean;
  setOpen: (isOpen: boolean) => void;
  setTemplateManagerModalOpen: (isOpen: boolean) => void;
  options?: Template[];
  onSelectTemplate: (template: Template) => void;
  template: Template;
}

const TemplateManager: React.FC<TemplateManagerProps> = ({
  isOpen = false,
  setOpen,
  options,
  setTemplateManagerModalOpen = () => {},
  onSelectTemplate,
  template,
}) => (
  <PopOut
    alignBlock="start"
    alignInline="start"
    isOpen={isOpen}
    setIsOpen={setOpen}
    closeOnClickOutside
    automationName="TemplateManagerPopOut"
  >
    <InnerWrapper data-automation="TemplatePopOutInnerWrapper">
      <Button
        id="Template Manager"
        icon={<StyledArrowDown />}
        iconPosition="right"
        state="secondary"
        buttonText={template?.name}
        onClick={() => setOpen(true)}
        disabled={false}
        style={{ padding: 0, paddingLeft: '11px', outline: 'none' }}
      />
    </InnerWrapper>
    <StyledPopOutBody automationName="StyledPopOutBody">
      <PopOutScrollView>
        {options?.map(option => {
          const { name, type } = option;
          return (
            <ListItemContainer
              key={name}
              data-automation="TemplateListItemContainer"
              onClick={() => onSelectTemplate(option)}
              isHighlighted={template.id === option.id}
            >
              <TemplateNameText>{name}</TemplateNameText>
              <TemplateTypeText>{_capitalize(type)}</TemplateTypeText>
            </ListItemContainer>
          );
        })}
      </PopOutScrollView>
      <FooterManageButtonContainer>
        <Button
          buttonText="Manage"
          id="Template Manage Button"
          state="secondary"
          onClick={() => setTemplateManagerModalOpen(true)}
          disabled={false}
          style={{ padding: 0, outline: 'none' }}
        />
      </FooterManageButtonContainer>
    </StyledPopOutBody>
  </PopOut>
);

export default TemplateManager;
